/**
 * 退押金
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/paymanage/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableAction as tac, RoleType } from '../types';
import AuditModal from './components/AuditModal';
import RefundModal from './components/RefundModal';
import RejectRefundModal from './components/RejectRefundModal';

class Main extends React.Component {

    state = {
        resultData: {},
        tel: '',
        receiver: '',
        auditState: {},
        refundState: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        auditStateEnum: [],
        refundStateEnum: [],
        showAudit: false,
        showRefund: false,
        showRejectRefund: false,
        curItem: {}
    }

    componentDidMount() {

        this.getEnum('DepositAuditStatusEnum', res=>{
            this.setState({auditStateEnum: res.result});
        });
        this.getEnum('RiderDepositRecordRefundStatus', res=>{
            this.setState({refundStateEnum: res.result});
        });
    }

    getEnum = (enumName, cb)=>{
        let params = {enumName};
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', params, 'POST').then((res) => {
                cb(res);
            }).catch((e) => {
                message.error(e.message);
            });
    }

    postSearch = (params)=>{
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderDepositMisService.getDepositUseRecordList', params, 'POST').then((res) => {
                this.setState({resultData: res.result});
            }).catch((e) => {
                message.error(e.message);
            });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { tel, receiver, auditState, refundState, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            riderTel: tel,
            riderName: receiver,
            refundType: 'REFUND',
            refundStatus: refundState.code,
            status: auditState.code,
            beginGmtCreate: startTime,
            endGmtCreate: endTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.postSearch(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ tel: '', receiver: '', state: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history } = this.props;
        this.setState({curItem: item});
        switch (type) {
            case 'detail':
                history.push({ pathname: `/home/finance/paymanage/refundDepositDetail/${key}` });
                break;
            case 'audit':
                this.setState({showAudit: true});
                break;
            case 'refund':
                this.setState({showRefund: true});
                break;
            case 'rejectRefund':
                this.setState({showRejectRefund: true});
                break;
        }
    }

    onAuditOk = ()=>{
        this.setState({showAudit: false}, ()=>{
            this._searchHandle();
        });
    };

    onAuditClose = ()=>{
        this.setState({showAudit: false});
    };

    onRefundOk = ()=>{
        this.setState({showRefund: false}, ()=>{
            this._searchHandle();
        });
    };

    onRefundClose = ()=>{
        this.setState({showRefund: false});
    };

    onRejectRefundOk = ()=>{
        this.setState({showRejectRefund: false}, ()=>{
            this._searchHandle();
        });
    };

    onRejectRefundClose = ()=>{
        this.setState({showRejectRefund: false});
    };

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'refund':
                return <PayModal title='付款' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        console.log(this.state.showAudit);
        const { resultData, tel, receiver, auditState, refundState, startTime, endTime, auditStateEnum, refundStateEnum } = this.state;

        return (
            <KeepAlive id="refund" render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='手机号'
                                placeholder='请输入'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='姓名'
                                placeholder='请输入'
                                value={receiver}
                                bindThis={this}
                                bindName='receiver'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='审核状态'
                                placeholder='请选择'
                                renderData={auditStateEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={auditState.value}
                                bindThis={this}
                                bindName='auditState'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='退款状态'
                                placeholder='请选择'
                                renderData={refundStateEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={refundState.value}
                                bindThis={this}
                                bindName='refundState'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='新建时间'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={resultData} tableAction={this._tableAction} paginationChange={this._paginationChange} />

                    {this.state.showAudit ? <AuditModal item={this.state.curItem} onOk={this.onAuditOk} onClose={this.onAuditClose} /> : null}
                    {this.state.showRefund ? <RefundModal item={this.state.curItem} onOk={this.onRefundOk} onClose={this.onRefundClose} /> : null}
                    {this.state.showRejectRefund ? <RejectRefundModal item={this.state.curItem} onOk={this.onRejectRefundOk} onClose={this.onRejectRefundClose} /> : null}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
};
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { ...model.actions })(Main);